module.exports = __webpack_public_path__ + "d7159c9545e90afa9173b0f99dc660a6.png";